export const handleScroll = (
  scrollRef: React.RefObject<HTMLElement>,
  notSmooth = false
) =>
  scrollRef?.current?.scrollIntoView({
    behavior: notSmooth ? 'auto' : 'smooth',
    block: 'start',
  });

export const handleScrollTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const scrollToElement = (elementId: string) => {
  const targetElement = document.getElementById(elementId);
  if (targetElement) {
    handleScroll({ current: targetElement });
  }
};
